export default {
  "shadow": "-xBN1",
  "playIcon": "XvtQC"
};